module.exports = __webpack_public_path__ + "static/media/kate-mara.83468ef7.jpg";